import { ApexOptions } from 'apexcharts';

import { TFunction } from 'i18next';
import { PestsVsTracesChartData } from 'api/analitics/EncCharts/types';

export const pestVsSightingsChartOptions = (data: PestsVsTracesChartData, t: TFunction) => {
  const chartOptions: ApexOptions = {
    series: [
      {
        name: t('ChartsAnalitics.encounters_charts.Number of pests being spotted.series.first'),
        data: data?.series[0]?.data || [],
      },
      {
        name: t('ChartsAnalitics.encounters_charts.Number of pests being spotted.series.second'),
        data: data?.series[1]?.data || [],
      },
    ],
    chart: {
      height: 350,
      type: 'area',
      zoom: {
        enabled: true,
      },
      toolbar: {
        show: true,
      },
    },
    markers: {
      size: 3,
      shape: 'circle',
    },
    stroke: {
      width: [3, 3],
      curve: 'smooth',
    },
    xaxis: {
      title: {
        text: t('ChartsAnalitics.encounters_charts.Number of pests being spotted.x_axis_title'),
        style: {
          fontSize: '12px',
        },
      },
      categories: data?.labels || [],
      type: 'category',
      tickPlacement: 'on',
    },
    yaxis: {
      title: {
        text: t('ChartsAnalitics.encounters_charts.Number of pests being spotted.y_axis_title'),
        style: {
          fontSize: '12px',
        },
      },
      min: 0,
      stepSize: 1,
      forceNiceScale: false,
      decimalsInFloat: 0,
      labels: {
        formatter: value => Math.floor(value).toString(),
      },
    },
    colors: ['#EED32E', '#6A37D4'],
  };

  return chartOptions;
};
